import { getToken, _fetch } from "./apiHelper";
import { protectedResources } from "../config/authConfig";
import { ComplianceResponse } from "../types/complianceResponse";
import { OverallActivityResult} from "../types/overallActivityResult";
import { OverallIndustryResult } from "../types/overallIndustryResult";
import { CostsConfig } from "../types/costsConfig";
import { MetricOverallResult } from "../types/metricOverallResult";

const getEndpointDataPerProjectCode = async (
  endpoint:string,
  projectCode:string[],
  controller? : AbortController
  ) => {
  const accessToken = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  // Construct the query string
  const queryParams = new URLSearchParams();
  projectCode.forEach((code) => queryParams.append("projectCode", code));

  const url = `${protectedResources.api.dashboard}/${endpoint}?${queryParams}`;

  const options = {
    method: "GET",
    headers: headers,
    cache: "no-cache" as RequestCache,
    signal: controller?.signal as AbortSignal
  };

  return _fetch(url, options);
};

const getEndpointDataForActivity = async (
  endpoint:string,
  projectCode:string,
  activityName:string,
  controller?: AbortController
  ) => {
  const accessToken = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  // Construct the query string
  const queryParams = new URLSearchParams();
  queryParams.append("projectCode", projectCode);
  queryParams.append("activityName", activityName);

  const url = `${protectedResources.api.dashboard}/${endpoint}?${queryParams}`;

  const options = {
    method: "GET",
    headers: headers,
    cache: "no-cache" as RequestCache,
    signal : controller?.signal as AbortSignal
  };

  return _fetch(url, options);
};

export const getUsersPerDay = async (projectCode: string[], controller : AbortController) => {
  return await getEndpointDataPerProjectCode("UsersPerDay", projectCode, controller);
};

export const getActivitiesStatus = async (projectCode: string[] , controller : AbortController) => {
  return await getEndpointDataPerProjectCode("ActivitiesStatus", projectCode, controller);
};

export const getPainReportsPerDay = async (projectCode: string[],controller : AbortController) => {
  return await getEndpointDataPerProjectCode("PainReportsPerDay", projectCode, controller);
};

export const getActivityReportsPerDay = async (projectCode: string[], controller : AbortController) => {
  return await getEndpointDataPerProjectCode("ActivityReportsPerDay", projectCode, controller);
};

export const getFeedbackReportsPerDay = async (projectCode: string[], controller : AbortController) => {
  return await getEndpointDataPerProjectCode("FeedbackReportsPerDay", projectCode,controller);
};

export const getTotalPainReports = async (projectCode: string[], controller: AbortController): Promise<number[]> => {
  return await getEndpointDataPerProjectCode("TotalPainReports", projectCode, controller);
}

export const getTotalUsers = async (projectCode: string[], controller : AbortController): Promise<number[]> => {
  return await getEndpointDataPerProjectCode("TotalUsers", projectCode, controller);
}

export const getTotalActivityLogs = async (projectCode: string[], controller : AbortController): Promise<number[]> => {
  return await getEndpointDataPerProjectCode("TotalActivityLogs", projectCode, controller);
}

export const getUsersCompliance = async (projectCode: string[], controller : AbortController): Promise<ComplianceResponse> => {
  return await getEndpointDataPerProjectCode("UsersCompliance", projectCode, controller);
}

export const getUsersWithHighMLI = async (projectCode: string[], controller : AbortController): Promise<MetricOverallResult[]> => {
  return await getEndpointDataPerProjectCode("UsersWithHighMLI", projectCode, controller);
}

export const getUsersWithHighPain = async (projectCode: string[], controller : AbortController): Promise<MetricOverallResult[]> => {
  return await getEndpointDataPerProjectCode("UsersWithHighPain", projectCode, controller);
}

export const getProjectCodeActivities = async (projectCode: string, controller? : AbortController): Promise<string[]> => {
  return await getEndpointDataPerProjectCode("ProjectCodeActivities", [projectCode], controller);
}

export const getOverallActivitiesResults = async (projectCode: string, controller?: AbortController): Promise<OverallActivityResult[]> => {
  return await getEndpointDataPerProjectCode("ProjectActivitiesResults", [projectCode], controller);
}

export const getOverallIndustriesResults = async (projectCode: string, controller?: AbortController): Promise<OverallIndustryResult[]> => {
  return await getEndpointDataPerProjectCode("ProjectIndustryResults", [projectCode], controller);
}

export const getOrganizationInputCosts = async (organizationId: string, controller?: AbortController): Promise<CostsConfig> => {

  const accessToken = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  // Construct the query string
  const queryParams = new URLSearchParams();
  queryParams.append("organizationId", organizationId);
  const url = `${protectedResources.api.dashboard}/OrganizationInputCosts?${queryParams}`;

  const options = {
    method: "GET",
    headers: headers,
    cache: "no-cache" as RequestCache,
    signal: controller?.signal as AbortSignal
  };

  return _fetch(url, options);

}


export const postOrganizationInputCosts = async (costsConfig: CostsConfig, controller?: AbortController) => {
  const accessToken = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const url = `${protectedResources.api.dashboard}/OrganizationInputCosts`;
  const options = {
    method: "POST",
    headers: headers,
    cache: "no-cache" as RequestCache,
    body: JSON.stringify(costsConfig),
    signal: controller?.signal as AbortSignal
  };

  return _fetch(url, options);

} 

